/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, inject } from "@angular/core";
import {
    PlatformLegalEntityResourceService
} from "@well/platform-administration/company/resource-services";
import {JsonApiResource} from "@irian-ro/abstract-resource";
import {PlatformLegalEntityDTO} from "@well/platform-administration/company/domain";
import {Observable} from "rxjs";

@Injectable({
    providedIn: "root"
    }
)
export class PlatformLegalEntityDetailPageService {
    private platformLegalEntityResourceService = inject(PlatformLegalEntityResourceService);


    getActivePlatformLegalEntityTemplate(): Observable<JsonApiResource<PlatformLegalEntityDTO, any>> {
        return this.platformLegalEntityResourceService.getActivePlatformLegalEntityTemplate();
    }

    update(platformLegalEntityDTO: PlatformLegalEntityDTO): Observable<JsonApiResource<PlatformLegalEntityDTO, any>> {
        return this.platformLegalEntityResourceService.update(platformLegalEntityDTO);
    }
}
